import { Controller } from "@hotwired/stimulus";
import { loadLitepicker } from "../lib/litepicker_loader.ts";

// Single-input date/range picker. The same input works for both modes —
// singleMode picks one date, range mode (default) lets you click a start
// day then an end day in the same calendar and writes "start - end" back
// into the one input. data-litepicker-single-value toggles the mode.
export default class extends Controller {
  static values = { single: Boolean };

  declare readonly singleValue: boolean;

  private picker?: any;

  async connect() {
    const Litepicker = await loadLitepicker();

    this.picker = new Litepicker({
      element: this.element as HTMLInputElement,
      singleMode: this.singleValue,
      format: "MMM D, YYYY",
      numberOfMonths: this.singleValue ? 1 : 2,
      numberOfColumns: this.singleValue ? 1 : 2,
    });
  }

  disconnect() {
    this.picker?.destroy();
  }
}
